import { _ as r } from "../internals/export.js";
import { t } from "../internals/try-node-require.js";
import { g as e } from "../internals/get-built-in.js";
import { f as n } from "../internals/fails.js";
import { o } from "../internals/object-create.js";
import { c as s } from "../internals/create-property-descriptor.js";
import "../internals/object-define-property.js";
import { d as i } from "../internals/define-built-in.js";
import { d as a } from "../internals/define-built-in-accessor.js";
import { h as m } from "../internals/has-own-property.js";
import { a as c } from "../internals/an-instance.js";
import { a as p } from "../internals/an-object.js";
import { e as f } from "../internals/error-to-string.js";
import { n as l } from "../internals/normalize-string-argument.js";
import { d as u } from "../internals/dom-exception-constants.js";
import { e as d } from "../internals/error-stack-clear.js";
import { i as j } from "../internals/internal-state.js";
import { d as g } from "../internals/descriptors.js";
import { __exports as h } from "../../../_virtual/object-define-property.js";
var y = h.f,
  b = "DOMException",
  v = "DATA_CLONE_ERR",
  w = e("Error"),
  E = e(b) || function () {
    try {
      new (e("MessageChannel") || t("worker_threads").MessageChannel)().port1.postMessage(new WeakMap());
    } catch (r) {
      if (r.name == v && 25 == r.code) return r.constructor;
    }
  }(),
  _ = E && E.prototype,
  k = w.prototype,
  M = j.set,
  x = j.getterFor(b),
  C = ("stack" in w(b)),
  D = function D(r) {
    return m(u, r) && u[r].m ? u[r].c : 0;
  },
  O = function O() {
    c(this, S);
    var r = arguments.length,
      t = l(r < 1 ? void 0 : arguments[0]),
      e = l(r < 2 ? void 0 : arguments[1], "Error"),
      n = D(e);
    if (M(this, {
      type: b,
      name: e,
      message: t,
      code: n
    }), g || (this.name = e, this.message = t, this.code = n), C) {
      var o = w(t);
      o.name = b, y(this, "stack", s(1, d(o.stack, 1)));
    }
  },
  S = O.prototype = o(k),
  A = function A(r) {
    return {
      enumerable: !0,
      configurable: !0,
      get: r
    };
  },
  R = function R(r) {
    return A(function () {
      return x(this)[r];
    });
  };
g && (a(S, "code", R("code")), a(S, "message", R("message")), a(S, "name", R("name"))), y(S, "constructor", s(1, O));
var q = n(function () {
    return !(new E() instanceof w);
  }),
  z = q || n(function () {
    return k.toString !== f || "2: 1" !== String(new E(1, 2));
  }),
  F = q || n(function () {
    return 25 !== new E(1, "DataCloneError").code;
  });
q || 25 !== E[v] || _[v], r({
  global: !0,
  constructor: !0,
  forced: q
}, {
  DOMException: q ? O : E
});
var L = e(b),
  N = L.prototype;
for (var T in z && E === L && i(N, "toString", f), F && g && E === L && a(N, "code", A(function () {
  return D(p(this).name);
})), u) if (m(u, T)) {
  var W = u[T],
    B = W.s,
    G = s(6, W.c);
  m(L, B) || y(L, B, G), m(N, B) || y(N, B, G);
}